import { useUsersQuery } from './useUsersQuery';

import { createMutationHook } from '~/shared/providers/api';

export interface CoreUsersDisableBulkMutationParams {
  userIds: string[];
}

export const useCoreUsersDisableBulkMutation = createMutationHook(
  'settings.teamPermissions.usersDisable',
  (params: CoreUsersDisableBulkMutationParams) => ({
    coreUsersDisable: {
      __args: {
        input: {
          userIds: params.userIds,
        },
      },
      successCount: true,
      failedCount: true,
      failedIds: true,
    },
  }),
  {
    invalidateQueries: [useUsersQuery],
  },
);
